import { Suspense, forwardRef, lazy } from 'react';
import type { AiStarsProps, AiStarsRef } from './AiStars';

export type { AiStarsRef };

const Component = lazy(() =>
  import('./AiStars').then((module) => ({ default: module.AiStars })),
);

export const AiStars = forwardRef((props: AiStarsProps, ref) => (
  <Suspense fallback={null}>
    <Component {...props} ref={ref} />
  </Suspense>
));
